export const TEN_MINUTES = 10 * 60 * 1000
export const STORYOUS_STORAGE_KEY = 'storyous_token'

export const GET_STORYOUS_TOKEN_QUERY_KEY = 'get-storyous-token'
